import { Component, Input, HostBinding } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ChartConfiguration } from 'chart.js';
import { ChartFullscreenDialogComponent, ChartFullscreenDialogData } from '../chart-fullscreen-dialog/chart-fullscreen-dialog.component';

@Component({
  selector: 'app-chart-expandable-card',
  templateUrl: './chart-expandable-card.component.html',
  styleUrls: ['./chart-expandable-card.component.scss'],
})
export class ChartExpandableCardComponent {
  @Input() title = '';
  @Input() tooltip = '';
  @Input() chartData!: ChartConfiguration<any>['data'];
  @Input() chartOptions!: ChartConfiguration<any>['options'];
  @Input() chartType: string = 'bar';
  @Input() dynamicHeight?: number;
  @Input() dynamicWidth?: number;
  @Input() scrollDirection: 'vertical' | 'horizontal' = 'vertical';

  @HostBinding('class.scroll-h') get isHorizontal() { return this.scrollDirection === 'horizontal'; }

  constructor(private dialog: MatDialog) {}

  openFullscreen(): void {
    if (this.dialog.openDialogs.length > 0) return;

    this.dialog.open(ChartFullscreenDialogComponent, {
      data: {
        title: this.title,
        tooltip: this.tooltip,
        chartData: this.chartData,
        chartOptions: {
          ...this.chartOptions,
          responsive: true,
          maintainAspectRatio: false,
        },
        chartType: this.chartType,
      } as ChartFullscreenDialogData,
      maxWidth: '90vw',
      maxHeight: '90vh',
      width: '85vw',
      height: '80vh',
      panelClass: 'chart-fullscreen-panel',
      restoreFocus: true,
    });
  }
}
